import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import Dropzone from 'react-dropzone';
import { PlannerStore } from '../../store';
import { css } from 'emotion';
import PlannerFileLoadingModal from '../Planner/PlannerFileLoadingModal';

interface DutyUploadTabProps extends WithTranslateProps {
  secretariatId?: number;
  refresh: () => void;
  PlannerStore?: Instance<typeof PlannerStore>;
}

interface DutyUploadTabState {
  fileIsLoading?: boolean;
  modalFileLoadingOpened: boolean;
  dutiesImportError: string[];
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const boxed = css({
  border: '1px solid green',
  height: '200px',
});

@inject('PlannerStore')
@observer
class DutyUploadTab extends React.Component<DutyUploadTabProps, DutyUploadTabState> {
  state = {
    fileIsLoading: false,
    modalFileLoadingOpened: false,
    dutiesImportError: [],
  } as DutyUploadTabState;

  cleanupBuffer = (buffer) => {
    return buffer.substring(39, 100).replace(/\//g, '-');
  };

  onImportModalClose = () => {
    this.setState({
      modalFileLoadingOpened: false,
      fileIsLoading: false,
    });
  };

  render() {
    const { fileIsLoading, modalFileLoadingOpened, dutiesImportError } = this.state;
    const { PlannerStore } = this.props;
    return (
      <Container>
        <TranslatedMessage id={TLCode.ROSTER_UploadDuties} />
        &nbsp;
        <Dropzone
          multiple={false}
          onDrop={(acceptedFiles) => {
            console.log(acceptedFiles);
            const reader = new FileReader();
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            reader.onload = () => {
              // Do whatever you want with the file contents
              const binaryStr = reader.result;
              const buffer = binaryStr!.toString();
              const buffer2 = this.cleanupBuffer(buffer);
              console.log(binaryStr);
            };
            acceptedFiles.forEach(async (file) => {
              this.setState({
                fileIsLoading: true,
                modalFileLoadingOpened: true,
              });
              const errors = await PlannerStore!.uploadFile(file);
              // @ts-ignore
              this.setState({ fileIsLoading: false, dutiesImportError: errors });
            });
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()} className={boxed.toString()}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop ici d'un fichier CSV, ou cliquer pour sélectionner un fichier</p>
                <p>Exemple de contenu</p>
                <br />
                <div>Date;Type service de garde;N° APB</div>
                <div>24/11/2020;Garde de jour;123456</div>
                <div>25/11/2020;nuit;234567</div>
                <p>26/11/2020;jour/nuit;345678</p>
              </div>
            </section>
          )}
        </Dropzone>
        <PlannerFileLoadingModal
          fileIsLoading={fileIsLoading}
          modalOpened={modalFileLoadingOpened}
          onClosed={this.onImportModalClose}
          errors={dutiesImportError}
        />
      </Container>
    );
  }
}

export default withTranslate(DutyUploadTab);
